{
  "title": "You have been logged out",
  "content": "This is because your account has been logged into by another device or browser. Please contact us if this was not you.",
  "signInLink": "Back to Sign in"
}
